// 📄 RenderTypographyField.jsx
import { Box, Typography } from "@mui/material";

const ViewUser = ({ label, value, labelWidth }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 1,
        mb: 1,
      }}
    >
      <Typography
      //  variant="body2"
        sx={{
          minWidth: { sm: labelWidth },
          alignSelf: { sm: "center" },
          fontWeight: 600,
        }}
      >
        {label}
      </Typography>

      <Typography
      //  variant="body2"
        sx={{
          flex: 1,
          alignSelf: "center",
          borderRadius: 1,
          px: 1.5,
          py: 0.75,
        }}
      >
        : {value ?? "-"}
      </Typography>
    </Box>
  );
};

export default ViewUser;
